var _style, _ellipse, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVaultClipart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 383.6 415.9",
    style: {
      enableBackground: "new 0 0 383.6 415.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#212552;}\n\t.st1{fill:#92D6E9;}\n\t\n\t\t.st2{opacity:0.3;fill:#0A1E2B;stroke:#0A1E2B;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;enable-background:new    ;}\n\t.st3{fill:none;stroke:#212552;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#CBEDF9;}\n\t.st5{fill:#E8F9FF;}\n\t\n\t\t.st6{opacity:0.23;fill:#0A1E2B;stroke:#0A1E2B;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;enable-background:new    ;}\n\t.st7{fill:none;stroke:#212552;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:#FFEA9E;}\n\t.st9{fill:#EDC75D;}\n\t.st10{fill:none;stroke:#212552;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#5F9E71;stroke:#212552;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:#90C49E;}\n\t.st13{fill:#FFFFFF;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_75_",
    className: "st0",
    cx: 182.6,
    cy: 393.1,
    rx: 182.6,
    ry: 22.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st1",
    d: "M142.1,377v-7.4c0-3.3-2.7-6-6-6h-66c-3.3,0-6,2.7-6,6v22c0,3.3,2.7,6,6,6H114 c4.8,0,9.4-1.9,12.8-5.3L142.1,377z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st2",
    d: "M136.1,363.6h-66c-3.3,0-6,2.7-6,6V390h65l13-13v-7.4C142.1,366.3,139.4,363.6,136.1,363.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st1",
    d: "M223.1,377v-7.4c0-3.3,2.7-6,6-6h66c3.3,0,6,2.7,6,6v22c0,3.3-2.7,6-6,6h-43.9 c-4.8,0-9.4-1.9-12.8-5.3L223.1,377z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st2",
    d: "M295.1,363.6h-66c-3.3,0-6,2.7-6,6v7.4l13,13h65v-20.4C301.1,366.3,298.4,363.6,295.1,363.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st3",
    d: "M142.1,377v-7.4c0-3.3-2.7-6-6-6h-66c-3.3,0-6,2.7-6,6v22c0,3.3,2.7,6,6,6H114 c4.8,0,9.4-1.9,12.8-5.3L142.1,377z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st3",
    d: "M223.1,377v-7.4c0-3.3,2.7-6,6-6h66c3.3,0,6,2.7,6,6v22c0,3.3-2.7,6-6,6h-43.9 c-4.8,0-9.4-1.9-12.8-5.3L223.1,377z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st4",
    d: "M312.6,377.1h-260c-22.1,0-40-17.9-40-40v-260c0-22.1,17.9-40,40-40h260c22.1,0,40,17.9,40,40 v260C352.6,359.2,334.7,377.1,312.6,377.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st5",
    d: "M312.6,37.1h-260c-22.1,0-40,17.9-40,40v23c0-22.1,17.9-40,40-40h260c22.1,0,40,17.9,40,40v-23 C352.6,55,334.7,37.1,312.6,37.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_58_",
    className: "st6",
    points: "251.3,36.7 276.9,36.7 259.6,73.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st1",
    d: "M312.6,354.1h-260c-22.1,0-40-17.9-40-40v23c0,22.1,17.9,40,40,40h260c22.1,0,40-17.9,40-40 v-23C352.6,336.2,334.7,354.1,312.6,354.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st3",
    d: "M312.6,377.1h-260c-22.1,0-40-17.9-40-40v-260c0-22.1,17.9-40,40-40h260c22.1,0,40,17.9,40,40 v260C352.6,359.2,334.7,377.1,312.6,377.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    className: "st5",
    d: "M300.6,73.1h-236c-8.8,0-16,7.2-16,16v8c0-8.8,7.2-13,16-13h236c8.8,0,16,4.2,16,13v-8 C316.6,80.2,309.4,73.1,300.6,73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_83_",
    className: "st1",
    d: "M300.6,328.1h-236c-8.8,0-16-7.2-16-16v13c0,8.8,7.2,16,16,16h236c8.8,0,16-7.2,16-16v-13 C316.6,320.9,309.4,328.1,300.6,328.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st3",
    d: "M64.6,341.1c-8.8,0-16-7.2-16-16v-236c0-8.8,7.2-16,16-16h236c8.8,0,16,7.2,16,16v236 c0,8.8-7.2,16-16,16H64.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    className: "st6",
    d: "M287.9,302.2h-2c-2.2,0-4-1.8-4-4v-152c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4v152 C291.9,300.4,290.1,302.2,287.9,302.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st1",
    d: "M287.9,282.2h-2c-2.2,0-4-1.8-4-4v-152c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4v152 C291.9,280.4,290.1,282.2,287.9,282.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st3",
    d: "M287.9,282.2h-2c-2.2,0-4-1.8-4-4v-152c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4v152 C291.9,280.4,290.1,282.2,287.9,282.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_39_",
    className: "st6",
    cx: 182.6,
    cy: 215.1,
    r: 65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_32_",
    className: "st4",
    cx: 182.6,
    cy: 207.1,
    r: 65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_5_",
    className: "st3",
    cx: 182.6,
    cy: 207.1,
    r: 65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_34_",
    className: "st1",
    cx: 182.6,
    cy: 207.1,
    r: 54
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_10_",
    className: "st7",
    x1: 182.6,
    y1: 166.1,
    x2: 182.6,
    y2: 248.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_8_",
    className: "st7",
    x1: 223.6,
    y1: 207.1,
    x2: 141.6,
    y2: 207.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12_",
    className: "st7",
    x1: 211.6,
    y1: 178.1,
    x2: 153.6,
    y2: 236.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_11_",
    className: "st7",
    x1: 211.6,
    y1: 236.1,
    x2: 153.6,
    y2: 178.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st2",
    d: "M182.6,254.8L182.6,254.8c-13.8,0-25-11.2-25-25v-25h50v25 C207.6,243.6,196.4,254.8,182.6,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st6",
    d: "M48.6,169.6L48.6,169.6c-4.4,0-8-3.6-8-8v-24c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v24 C56.6,166,53,169.6,48.6,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st6",
    d: "M48.6,300.1L48.6,300.1c-4.4,0-8-3.6-8-8v-24c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v24 C56.6,296.5,53,300.1,48.6,300.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st1",
    d: "M48.6,161.6L48.6,161.6c-4.4,0-8-3.6-8-8v-24c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v24 C56.6,158,53,161.6,48.6,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st1",
    d: "M48.6,292.6L48.6,292.6c-4.4,0-8-3.6-8-8v-24c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v24 C56.6,289,53,292.6,48.6,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st3",
    d: "M48.6,161.6L48.6,161.6c-4.4,0-8-3.6-8-8v-24c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v24 C56.6,158,53,161.6,48.6,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st3",
    d: "M48.6,292.6L48.6,292.6c-4.4,0-8-3.6-8-8v-24c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v24 C56.6,289,53,292.6,48.6,292.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_29_",
    className: "st8",
    cx: 182.6,
    cy: 207.1,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_72_",
    className: "st9",
    cx: 182.6,
    cy: 207.1,
    r: 11.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_9_",
    className: "st10",
    cx: 182.6,
    cy: 207.1,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    className: "st11",
    d: "M261.6,73.1h-68.5V20.9c0-4,3.2-7.2,7.2-7.2h54c4,0,7.2,3.2,7.2,7.2L261.6,73.1L261.6,73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    className: "st12",
    d: "M248.1,26.1h-14.6c0,3.4-2.7,6.1-6.1,6.1s-6.1-2.7-6.1-6.1h-14.7c-1.7,0-3.2,1.4-3.2,3.2v43.8 h47.8V29.3C251.3,27.5,249.8,26.1,248.1,26.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_56_",
    className: "st13",
    cx: 227.4,
    cy: 62.4,
    rx: 15,
    ry: 14.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st3",
    d: "M261.6,73.1h-68.5V20.9c0-4,3.2-7.2,7.2-7.2h54c4,0,7.2,3.2,7.2,7.2L261.6,73.1L261.6,73.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_22_",
    className: "st3",
    x1: 380.6,
    y1: 54.9,
    x2: 360.4,
    y2: 52.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_21_",
    className: "st3",
    x1: 332.5,
    y1: 23.2,
    x2: 329.5,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_16_",
    className: "st3",
    x1: 352.5,
    y1: 30.5,
    x2: 367,
    y2: 16
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultClipart);
export default __webpack_public_path__ + "static/media/vault-clipart.0c469fdadaa455a071240e520b3e90fe.svg";
export { ForwardRef as ReactComponent };